export const convertMention = (message) => {
    const result = message
        .replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/\n/g, '<br>');

    return result
        .replace(/@\[:([^\]]+)\]/g, "<a class='link_mention' data-id='$1'>@$1</a>")
        .replace(/@\[-[^:]+:([^\]]+)\]/g, "<a class='link_mention' data-id='$1'>@$1</a>")
        .replace(/@\[([^:]+):([^\]]+)\]/g, "<a href='/@@$1' class='link_mention' data-id='$1'>@$2</a>")
        .replace(/\\\[/g, '[')
        .replace(/\\\]/g, ']');
};
